import { call } from 'redux-saga/effects'
import * as client from '../../api/client'

export function* startGoogleAuth({oauthPopup}) {
 
    const resp = yield call(client.getGoogleOAuthIframeSrc)
    oauthPopup.location = resp.iframeSrc

    const listener = ({ data, origin }) => {
        window.removeEventListener('message', listener)
        if (data.indexOf('success') < 0 ) {
            /* eslint-disable no-console */
            console.log("Failed")
        } else {
            console.log("Success")
        }

        oauthPopup.close()
    }
    window.addEventListener('message', listener)
}



// WEBPACK FOOTER //
// ./src/redux/sagas/oauth.js